import Alpine from 'alpinejs';

const components = import.meta.glob('~/javascripts/alpine-components/*.js');
const promises = [];

const loadComponents = (container) => {
  container.querySelectorAll('[x-data]').forEach((el) => {
    const xData = el.getAttribute('x-data').trim();

    if (xData.startsWith('{')) return;

    let componentName;

    if (xData.includes('(')) {
      componentName = xData.slice(0, xData.indexOf('(')).trim();
    } else {
      componentName = xData;
    }

    const componentPath = `/javascripts/alpine-components/${componentName}.js`;
    if (!components[componentPath]) {
      console.error(`Alpine component not found: ${componentName}`);
      return;
    }

    const promise = components[componentPath]().then((module) => {
      Alpine.data(componentName, module.default);
    });
    promises.push(promise);
  });
};

loadComponents(document);

document.querySelectorAll('template').forEach((template) => {
  loadComponents(template.content);
});

Promise.all(promises).then(() => {
  window.Alpine = Alpine;
  Alpine.start();
});

document.body.addEventListener('htmx:afterSwap', (event) => {
  if (event.detail.target.querySelector('[x-data]')) {
    Alpine.destroyTree(event.detail.target);
    Alpine.initTree(event.detail.target);
  }
});
